// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Users Area
export class AreaWorkspaceIntegrations {
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(dataCore) {
        this.dataCore = dataCore;
    }
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Query (Read)
    /** Fetches integrations of one specific workspace by provided id
     * @param workspaceId - ID of the workspace
     * @returns Object with integrations of given workspace
     */
    async getIntegrations(workspaceId) {
        return this.dataCore.workspaceIntegrations(workspaceId);
    }
    /** Fetches redirect url for oauth of one specific workspace integration by workspace id and integration type
     * @param workspaceId - ID of the workspace
     * @param type - Type of integration
     * @returns Object with redirect url
     */
    async getRedirectUrl({ workspaceId, type, }) {
        return this.dataCore.workspaceIntegrationRedirectUrl({ workspaceId, type });
    }
    // --- --- --- --- --- --- --- --- --- ---
    // Git Providers
    /** Fetches Organizations
     * @param workspaceId - ID of the workspace
     * @param integrationId - ID of the integration
     * @returns
     */
    async fetchGitProviderOrganization({ workspaceId, integrationId, }) {
        return this.dataCore.fetchGitProvidersOrganization({
            workspaceId,
            integrationId,
        });
    }
    /** Fetches Projects
     * @param workspaceId - ID of the workspace
     * @param integrationId - ID of the integration
     * @param params - Query string parameters
     * @returns
     */
    async fetchGitProviderProjects({ workspaceId, integrationId, params, }) {
        return this.dataCore.fetchGitProviderProjects({
            workspaceId,
            integrationId,
            params,
        });
    }
    /** Fetches Repositaries
     * @param workspaceId - ID of the workspace
     * @param integrationId - ID of the integration
     * @param params - Query string parameters
     * @returns
     */
    async fetchGitProviderRepositories({ workspaceId, integrationId, params, }) {
        return this.dataCore.fetchGitProviderRepositories({
            workspaceId,
            integrationId,
            params,
        });
    }
    /** Fetches Branches
     * @param workspaceId - ID of the workspace
     * @param integrationId - ID of the integration
     * @param params - Query string parameters
     * @returns
     */
    async fetchGitProviderBranches({ workspaceId, integrationId, params, }) {
        return this.dataCore.fetchGitProviderBranches({
            workspaceId,
            integrationId,
            params,
        });
    }
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Mutations (Create/Delete/Write)
    /** Creates a new workspace integration via PAT by workspace id and PAT input
     * @param workspaceId - ID of the workspace
     * @param payload - PAT input
     * @returns Workspace integrations with updated integration
     */
    async createWorkspaceIntegrationAccessToken({ workspaceId, payload, }) {
        return this.dataCore.createWorkspaceIntegrationAccessToken({
            workspaceId,
            payload,
        });
    }
    /** Delete workspace integration's connection
     * @param workspaceId - ID of the workspace
     * @param integrationId - ID of the integration
     * @param credentialId - ID of the credential
     * @returns Workspace integrations with updated integration
     */
    async deleteWorkspaceIntegrationCredential(data) {
        return this.dataCore.deleteWorkspaceIntegrationCredential(data);
    }
    /** Delete workspace integration
     * @param workspaceId - ID of the workspace
     * @param integrationId - ID of the integration
     * @returns Workspace integrations with updated integration
     */
    async deleteWorkspaceIntegration(data) {
        return this.dataCore.deleteWorkspaceIntegration(data);
    }
}
